import "../../../styles/modal.scss";

import DropDownMenu from "./DropDownMenu";
import PropTypes from "prop-types";
import React from "react";
import {connect} from "react-redux";

const mapStateToProps = state => {
    return {
        innerHeight: state.view.innerHeight,
    };
};

class DropDown extends React.PureComponent {
    constructor(props){
        super(props);

        this.onCloseDropDown = this.onCloseDropDown.bind(this);
        this.eatClick = this.eatClick.bind(this);
    }

    componentWillUnmount() {
        if (this.props.onComponentWillUnmount) {
            this.props.onComponentWillUnmount();
        }
    }

    onCloseDropDown() {
        this.props.setDropDown(null);
    }
    eatClick(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    render() {
        const {
            rect,
            shiftLeft,
            below,
            isDroppedDown,
            children,
            style,
            heightFixed,
            left,
        } = this.props;

        const maxHeight = isDroppedDown ? innerHeight-(below?rect.bottom:rect.top) : (below?rect.bottom:rect.top);
        //innerHeight-rect.top; 
        const shiftTop = (heightFixed!=null && heightFixed>maxHeight) ? (below ? heightFixed-maxHeight : maxHeight-heightFixed ) : 0;
        const width = (style==null || style.width==null)?rect.width:style.width;
        const renderHeight = heightFixed || maxHeight;

        return (
            <React.Fragment>
                <div className="dim-screen" onClick={this.onCloseDropDown}/>
                <div className="modal-drop-down" onClick={this.onCloseDropDown} style={{
                    left: left ?  left : rect.left+(shiftLeft?rect.width-width:0),
                    top:rect.top+(below?rect.height:(isDroppedDown?0:-renderHeight))-shiftTop,
                    bottom:below?0:rect.height,
                    width:rect.width,
                    height:renderHeight,
                    ...style
                }}>
                    <DropDownMenu maxHeight={renderHeight} isDroppedDown={isDroppedDown}>
                        {children}
                    </DropDownMenu>
                </div>
            </React.Fragment>
        );
    }
}

DropDown.propTypes = {
    rect: PropTypes.object.isRequired,
    innerHeight: PropTypes.number.isRequired,
    shiftLeft: PropTypes.bool,
    children: PropTypes.node.isRequired,
    setDropDown: PropTypes.func.isRequired,
    onComponentWillUnmount: PropTypes.func,
    hideCard: PropTypes.bool,
    style: PropTypes.object,
    below: PropTypes.bool,
    isDroppedDown: PropTypes.bool,
    heightFixed: PropTypes.number,
    left: PropTypes.number,
};
DropDown.defaultProps = {
    shiftLeft: false,
    below: true,
    isDroppedDown: true,
};

export default connect(mapStateToProps)(DropDown);